<template>
  <a-popover placement="bottomLeft">
    <template slot="content">
      <div
        class="variable-content scroll_bar_beautify_ff"
        :class="{ 'email-var-contetnt':tabName==='email'}"
      >
        <em
          v-for="(item2, index) in varNewDatas"
          :key="index"
          class="gray-small-btn"
          @click="setVar(item2)"
        >{{ item2 }}</em>
      </div>
    </template>
    <div class="var-btn-box">
      <a-button> {{ $t('message["84"]') }}<i class="icon iconfont iconicon-test69" /></a-button>
      <a-tooltip placement="right">
        <template slot="title">
          <div
            slot="content"
            class="audit-tip-box"
          >
            {{ $t('message["231"]') }}
          </div>
        </template>
        <!-- <a-button class="tip-btn"><i class="icon iconfont icon-tip-notice-normal-gr tip-icon" /></a-button> -->
        <i class="icon iconfont icon-tip-notice-normal-gr tip-icon" />
      </a-tooltip>
      <!-- <span class="variable-tip"></span> -->
    </div>
  </a-popover>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('config/notice', ['varDatas', 'tabName']),
    isClue () {
      return this.item.noticetype === '线索联系提醒'
    },
    varNewDatas () {
      return this.isClue ? ['今日联系任务数'] : this.varDatas
    }

  },
  mounted () {
  },
  methods: {
    ...mapActions('config/notice', ['fetchVarDatas']),
    setVar (item) {
      this.$emit('getVar', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.variable-tip {
  color: #b3b3b3;
  margin-left: 10px;
}

.gray-small-btn {
  margin-right: 6px;
  cursor: pointer;
}

.variable-content {
  width: 244px;
  min-height: 94px;
  overflow-y: auto;
  em {
    font-style: normal;
    font-size: 12px;
    display: inline-block;
    height: 20px;
    line-height: 20px;
    margin-bottom: 16px;
    padding: 0 4px;
    color: #666;
    border: 1px solid #ebebeb;
    border-radius: 2px;
  }
}
.email-var-contetnt {
  width: 200px;
}
.var-btn-box {
  display: inline-block;
  margin-left: 16px;
}
.icon-tip-notice-normal-gr {
  color: #b3b3b3;
}
</style>
